import React, { Component } from 'react';
import { connect } from 'react-redux';
import { tabClicked } from './../../../actions/wrapperTabActions';
//import React from 'react';

//import { wrapperTabsActions } from '../../../reducers/wrapperTabsReducers';
//import { wrapperTabsReducers } from './../../reducers/wrapperTabsReducers';

//import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import _ from 'lodash';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  default_tabStyle:{
    background: "#FFFFFF",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.12)",
    borderRadius: 4,
    color: '#666666',
    padding: 0,
    height: 30,
    fontSize: 16,
    margin: '2px 5px 2px 12px',
    '&:nth-of-type(1)':{
      backgroundImage: "url(../../../../assets/svg/learn/theory.svg)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "20px 15px",
    },
    '&:nth-of-type(2)':{
      backgroundImage: "url(../../../../assets/svg/learn/question.svg)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "15px 15px",
    },
    '&:nth-of-type(3)':{
      backgroundImage: "url(../../../../assets/svg/learn/video.svg)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "20px 15px",
    },
    '&:nth-of-type(4)':{
      backgroundImage: "url(../../../../assets/svg/learn/audio.svg)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "20px 15px",
    },
   },
   SelectedTab:{
    border: '1px solid #1d7dea'
   },
    active_tab:{
      border: "1px solid #1D7DEA",
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.12)',
      margin: '2px 0 2px 5px',
      borderRadius: 4,
      height: 30,
      fontSize: 16,
      '&:nth-of-type(1)':{
        backgroundImage: "url(../../../../assets/svg/learn/theory.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "20px 15px",
      },
      '&:nth-of-type(2)':{
        backgroundImage: "url(../../../../assets/svg/learn/question.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "15px 15px",
      },
      '&:nth-of-type(3)':{
        backgroundImage: "url(../../../../assets/svg/learn/video.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "20px 15px",
      },
      '&:nth-of-type(4)':{
        backgroundImage: "url(../../../../assets/svg/learn/audio.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "20px 15px",
      },
   },
   indicatorColorStyle: {
    display: "none",
  },
});

class TabComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeValue: 0
    }
  }


  handleChange = (event, value, index) => {
    this.setState({ activeValue:value });
  }

  a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  render() {
    const {  pageNumber = 1, filledTab, pageTabState } = this.props;
    const {classes} = this.props;
    // const { activeValue } = this.state;
    return (
      <div>
        <Paper square style={{ boxShadow: "none" }}>
          <Tabs
            value={_.isUndefined(pageTabState[`page${pageNumber}`]) ? 1 : pageTabState[`page${pageNumber}`]['activeTab']}
            classes={{indicator: classes.indicatorColorStyle }}
            textColor="primary"
            onChange={this.handleChange}
            aria-label="disabled tabs example"
            border="1"
          >
            <img
              src="../../../../assets/svg/learn/theory.svg"
              alt=""
              style={{ marginRight: "-37px", marginLeft: "20px" }}
            />
            <Tab
             className=
             {pageTabState
              && pageTabState[`page${pageNumber}`]
              && pageTabState[`page${pageNumber}`]['activeTab'] === 1 ? classes.active_tab :classes.default_tabStyle}
              onClick={() => this.props.tabClicked(1, pageNumber)}
              disabled={
                _.isEmpty(filledTab)
                  ? false
                  : (filledTab[`page${pageNumber}`] === "question" ||
                      "video" || "audio") &&
                    filledTab[`page${pageNumber}`] !== ""
              }
              label="Theory"
              {...this.a11yProps(0)}
            />
            {/* <img
              src="../../../../assets/svg/learn/question.svg"
              alt=""
              style={{ marginRight: "-31px", marginLeft: "20px" }}
            /> */}
            <Tab
             className=
             {pageTabState
              && pageTabState[`page${pageNumber}`]
              && pageTabState[`page${pageNumber}`]['activeTab'] === 3 ? classes.active_tab :classes.default_tabStyle}
              onClick={() => this.props.tabClicked(3, pageNumber)}
              disabled={
                _.isEmpty(filledTab)
                  ? false
                  : (filledTab[`page${pageNumber}`] === "theory" ||
                      "video" || "audio") &&
                    filledTab[`page${pageNumber}`] !== ""
              }
              label="Question"
              {...this.a11yProps(1)}
            />
            {/* <img
              src="../../../../assets/svg/learn/video.svg"
              alt=""
              style={{ marginRight: "-43px", marginLeft: "20px" }}
            /> */}
            <Tab
             className=
             {pageTabState
              && pageTabState[`page${pageNumber}`]
              && pageTabState[`page${pageNumber}`]['activeTab'] === 5 ? classes.active_tab :classes.default_tabStyle}
              onClick={() => this.props.tabClicked(5, pageNumber)}
              disabled={
                _.isEmpty(filledTab)
                  ? false
                  : (filledTab[`page${pageNumber}`] === "theory" ||
                      "question" || "audio") &&
                    filledTab[`page${pageNumber}`] !== ""
              }
              label="Video"
              {...this.a11yProps(2)}
            />
            <Tab 
              className=
              {pageTabState
              && pageTabState[`page${pageNumber}`]
              && pageTabState[`page${pageNumber}`]['activeTab'] === 4 ? classes.active_tab :classes.default_tabStyle}
              onClick={() => this.props.tabClicked(4, pageNumber)} 
              disabled={
                _.isEmpty(filledTab)
                  ? false
                  : (filledTab[`page${pageNumber}`] === "theory" ||
                      "video" || "question") &&
                    filledTab[`page${pageNumber}`] !== ""
              }
              label="Audio" />
          </Tabs>
          
        </Paper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageTabState: state.wrapperTabsReducers.pageTabState,
  }
}

const mapDispatchToProps = {
  tabClicked
};

// const TabContainer = connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(TabComponent);

// export default TabContainer;

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(TabComponent));
